import { useEffect, useRef, useState } from 'react';
import { Download, FileSpreadsheet, FileText, ChevronDown } from 'lucide-react';
import { http } from '../lib/api';

const iso = (d) => d.toISOString().slice(0, 10);
const monthStart = (offset) => { const d = new Date(); return new Date(d.getFullYear(), d.getMonth() + offset, 1); };
const PRESETS = [
  ['Bu ay', () => [iso(monthStart(0)), iso(new Date())]],
  ['Geçen ay', () => [iso(monthStart(-1)), iso(new Date(monthStart(0) - 86400000))]],
  ['Son 3 ay', () => [iso(monthStart(-2)), iso(new Date())]],
  ['Son 6 ay', () => [iso(monthStart(-5)), iso(new Date())]],
];

export function RangeExport({ endpoint = '/export/commission', prefix = 'komisyon', formats = ['xlsx', 'pdf'], testId = 'export-commission-button', label = 'İndir' }) {
  const [open, setOpen] = useState(false); const [busy, setBusy] = useState('');
  const [range, setRange] = useState(() => PRESETS[3][1]());
  const ref = useRef();
  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close); return () => document.removeEventListener('mousedown', close);
  }, []);
  const download = async (format) => {
    setBusy(format);
    try {
      const r = await http.get(endpoint, { params: { format, start: range[0], end: range[1] }, responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      const a = Object.assign(document.createElement('a'), { href: url, download: `${prefix}-${range[0]}_${range[1]}.${format}` });
      document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
      setOpen(false);
    } finally { setBusy(''); }
  };
  const disabled = !!busy || !range[0] || !range[1];
  return <div className="export-wrap" ref={ref}>
    <button type="button" className="secondary-btn" onClick={() => setOpen(!open)} data-testid={testId}><Download size={16} /> {label} <ChevronDown size={14} /></button>
    {open && <div className="export-menu commission-export" data-testid={`${testId}-menu`}>
      <div className="preset-row">{PRESETS.map(([l, fn]) => <button type="button" key={l} className="chip" onClick={() => setRange(fn())} data-testid={`${testId}-preset-${l}`}>{l}</button>)}</div>
      <div className="range-row"><label>Başlangıç<input type="date" value={range[0]} max={range[1]} onChange={e => setRange([e.target.value, range[1]])} data-testid={`${testId}-start`} /></label><label>Bitiş<input type="date" value={range[1]} min={range[0]} onChange={e => setRange([range[0], e.target.value])} data-testid={`${testId}-end`} /></label></div>
      {formats.includes('xlsx') && <button type="button" onClick={() => download('xlsx')} disabled={disabled} data-testid="export-xlsx"><FileSpreadsheet size={15} /> Excel (.xlsx)</button>}
      {formats.includes('pdf') && <button type="button" onClick={() => download('pdf')} disabled={disabled} data-testid="export-pdf"><FileText size={15} /> PDF</button>}
      {formats.includes('csv') && <button type="button" onClick={() => download('csv')} disabled={disabled} data-testid="export-csv"><FileSpreadsheet size={15} /> CSV</button>}
    </div>}
  </div>;
}

export const CommissionExport = RangeExport;
